<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li>
      <a>{{ company_name }}:</a>
    </li>
    <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ul>
  <div class="right">
    <span>{{ today }}</span>
  </div>

  <div class="tag_powered_by">
    <span>Powered by: <b>Enertics</b></span>
  </div>
</div>
<div class="Content_outer">
  <div class="row">
    <div class="col-md-12">
      <div class="tab_right">
        <app-asset-health-box></app-asset-health-box>
      </div>
      <div class="tab_right">
        @if(cylinder_status){
        <span class="sprite_icon wifi_black"></span>
        <span class="seen"><b>Online</b>{{ lastFileProcessedTime }}
          <span matTooltip="Asset Running" class="cylinder_blue_dot"></span>
        </span>
        }@else {
        <span class="sprite_icon wifi_red"></span>
        <span class="seen"><b>Offline:</b>{{ lastFileProcessedTime }}
          <span matTooltip="Asset Idle" class="cylinder_gray_dot"></span>
        </span>
        }
        <span class="seen">
          <img style="width: 20px; height: 20px; cursor: pointer" src="./assets/settings.png"
            [matMenuTriggerFor]="menu" /></span>
      </div>
      <mat-menu #menu="matMenu" style="min-height: auto !important">
        <button class="dropdown-item-btn" (click)="viewAsset()">
          Settings
        </button>
      </mat-menu>

      <ul ngbNav #ctdTabset="ngbNav" class="nav nav-tabs custom_tab" style="
          position: fixed;
          width: 98%;
          background-color: #f7f7f7;
          z-index: 500;
          top: 97px;
        ">
        <li [ngbNavItem]="'tab-1'">
          <a ngbNavLink>Monitoring</a>
          <ng-template class="ml-4 mr-4" ngbNavContent>
            <app-asset-details-box [company_name]="company_name" [app_name]="application_name" [site_name]="site_name"
              [asset_name]="cylinder_name" [product_type]="'cylinder'"></app-asset-details-box>
            <div class="inner_gauge_box col-md-12 pl-1">
              <div class="chart_boxes_outer m_b_0 vibrationChartsView">
                <div class="ch_box acc" style="width: 75%;">
                  <div class="heading">Cylinder Vibration</div>

                  <div class="inner vibrationInner" style="gap: 10px" *ngIf="machineVibrationLoading">
                    <div class="cht" *ngFor="let i of [0, 1, 2, 3]">
                      <ng-container>
                        <div style="margin-top: 30px">
                          <div class="skeleton skeleton-chart" style="display: block"></div>
                          <div class="skeleton skeleton-chart-text"></div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="inner vibrationInner" *ngIf="!machineVibrationLoading">
                    <div class="cht" *ngFor="let meterdata1 of monitoringMeterShowVelocity">
                      <app-gauge-chart [canvasWidth]="160" [canvasHeight]="140" [needleValue]="meterdata1.needleValue"
                        [needleColor]="meterdata1.options.needleColor" [centralLabel]="centralLabel"
                        [options]="meterdata1.options" [name]="meterdata1.name" [bottomLabel]="meterdata1.bottomLabel">
                      </app-gauge-chart>
                    </div>
                    <div class="cht" *ngIf="gaugedisplay">
                      <app-gauge-chart
                        matTooltip="Peak Acceleration Threshold as per the Bernhard Guidlines or customer defined specific thresholds as per their process."
                        style="color: orange" [matTooltipClass]="'tooltip'" [ngClass]="{
                          big_font_chartbox:
                            monitoringmaxaccobj.hasneedle == false
                        }" [canvasWidth]="160" [canvasHeight]="140" [centralLabel]="vall"
                        [needleValue]="monitoringmaxaccobj.needleValue" [options]="Optionsss"
                        [name]="monitoringmaxaccobj.name" [bottomLabel]="monitoringmaxaccobj.bottomLabel">
                      </app-gauge-chart>
                    </div>
                  </div>
                </div>
                <div class="ch_box acc">
                  <div class="heading">Cylinder Temperature</div>
                  <div class="inner vibrationInner" style="gap: 100px" *ngIf="tempgaugeLoader">
                    <div class="cht" *ngFor="let i of [0, 1]" style="margin-top: 30px">
                      <div class="skeleton skeleton-chart" style="display: block"></div>
                      <div class="skeleton skeleton-chart-text"></div>
                    </div>
                  </div>
                  <div class="inner vibrationInner" style="justify-content: space-around"
                    *ngIf="displaytempgauge && !tempgaugeLoader">
                    <div class="cht flex_50 center_flex" *ngFor="let meterdata1 of monitoringTempratueResults">
                      <app-gauge-chart
                        matTooltip="Temperature Thresholds as per  IEEE 841 or customer defined specific thresholds as per their process."
                        style="color: orange" [matTooltipClass]="'tooltip'" [ngClass]="{
                          big_font_chartbox: meterdata1.hasneedle == false
                        }" [canvasWidth]="160" [canvasHeight]="140" [needleValue]="meterdata1.needleValue"
                        [options]="meterdata1.options" [name]="meterdata1.name" [bottomLabel]="meterdata1.bottomLabel">
                      </app-gauge-chart>
                    </div>
                  </div>
                </div>

                <div class="ch_box orien" style="
                    padding-left: 0px !important;
                    padding-right: 0px !important;
                  ">
                  <div class="container">
                    <div class="row">
                      <div class="col-sm" style="
                          padding-left: unset !important;
                          padding-right: unset !important;
                        ">
                        <div class="chatGraphTab">
                          <div class="heading">Cylinder Acoustics</div>
                          <div class="inner vibrationInner">
                            <div class="cht flex_50 center_flex">
                              <div *ngIf="acousticgaugeLoader" style="margin-top: 30px">
                                <div class="skeleton skeleton-chart" style="display: block"></div>
                                <div class="skeleton skeleton-chart-text"></div>
                              </div>
                              <!-- acousticgauge -->
                              <div *ngIf="!acousticgaugeLoader">
                                <app-gauge-chart
                                  matTooltip=" Machine acoustics thresholds as per the ISO 29821 or customer defined specific thresholds as per their process."
                                  style="color: orange" [matTooltipClass]="'tooltip'" [ngClass]="{
                                    big_font_chartbox:
                                      MonitoringMagacoustic?.hasneedle == false
                                  }" [canvasWidth]="160" [canvasHeight]="140" [needleValue]="
                                    MonitoringMagacoustic?.needleValue
                                  " [centralLabel]="centralLabel" [options]="MonitoringMagacoustic?.options"
                                  [name]="MonitoringMagacoustic?.name" [bottomLabel]="
                                    MonitoringMagacoustic?.bottomLabel
                                  ">
                                </app-gauge-chart>
                              </div>
                            </div>
                            <div class="cht flex_50 center_flex">
                              <div *ngIf="audibleLoader; else audibleId">
                                <div class="skeleton skeleton-chart" style="display: block"></div>
                                <div class="skeleton skeleton-chart-text"></div>
                              </div>
                              <ng-template #audibleId>
                                <div [matTooltip]="
                                    'Values are calculated for 1.5m from surface of asset.'
                                  " matTooltipClass="tooltip">
                                  <div class="img_outer">
                                    <img style="width: 90px; min-width: 90px;" src="./assets/ultrasonic_sensor.png"
                                      alt="ultrasonic sensor" />

                                    <div id="below_left" class="belowText">
                                      {{ monitoringAudibleValue }} dB-A
                                    </div>
                                    <div id="below_left">Audible</div>
                                  </div>
                                </div>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="chart_boxes_outer m_b_0 vibrationChartsView">
                <div class="ch_box acc" style="
                    width: 37%;
                    padding-left: 0px !important;
                    padding-right: 0px !important;
                    position: relative;
                  ">
                  <div class="heading">Process Parameters</div>
                  <button *ngIf="role !== 'OEM'" class="setting_btn_tf cursor-pointer" role="button"
                    (click)="openFlowPressModal()">
                    <img src="./assets/settings.png" class="cursor-pointer rotate-on-hover" />
                  </button>

                  <div class="inner vibrationInner" style="justify-content: space-around !important;">
                    <div class="cht flex center_flex">
                      <div *ngIf="flowLoader" style="margin-top: 30px">
                        <div class="skeleton skeleton-chart" style="display: block"></div>
                        <div class="skeleton skeleton-chart-text"></div>
                      </div>
                      <!-- acousticgauge -->
                      <div *ngIf="!flowLoader">
                        <app-gauge-chart
                          matTooltip=" Machine acoustics thresholds as per the ISO 29821 or customer defined specific thresholds as per their process."
                          style="color: orange" [matTooltipClass]="'tooltip'" [ngClass]="{
                            big_font_chartbox: flowDataObj?.hasneedle == false
                          }" [canvasWidth]="160" [canvasHeight]="140" [needleValue]="flowDataObj?.needleValue"
                          [centralLabel]="centralLabel" [options]="flowDataObj?.options" [name]="'Flow'"
                          [bottomLabel]="flowDataObj?.bottomLabel">
                        </app-gauge-chart>
                      </div>
                    </div>
                    <div class="cht flex center_flex">
                      <div *ngIf="pressureLoader" style="margin-top: 30px">
                        <div class="skeleton skeleton-chart" style="display: block"></div>
                        <div class="skeleton skeleton-chart-text"></div>
                      </div>
                      <!-- acousticgauge -->
                      <div *ngIf="!pressureLoader">
                        <app-gauge-chart
                          matTooltip=" Machine acoustics thresholds as per the ISO 29821 or customer defined specific thresholds as per their process."
                          style="color: orange" [matTooltipClass]="'tooltip'" [ngClass]="{
                            big_font_chartbox:
                              pressureDataObj?.hasneedle == false
                          }" [canvasWidth]="160" [canvasHeight]="140" [needleValue]="pressureDataObj?.needleValue"
                          [centralLabel]="centralLabel" [options]="pressureDataObj?.options" [name]="'Pressure'"
                          [bottomLabel]="pressureDataObj?.bottomLabel" [EnergyMeter]="true">
                        </app-gauge-chart>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chartBoxWrap ch_box acc">
                  <div class="heading">
                    Machine Health Status (12 hours)
                    <span matTooltip="The status bar is calculated from the peak sensor value recorded in the 30 mins window.
                                The Peak value may or may not correspond to an Unacceptable condition.
                                Please check the 24 Hours Machine Alert Summary for actual Unacceptable condition alerts
                                 " style="color: orange" [matTooltipClass]="'tooltip'">*</span>
                  </div>
                  <div id="sdchartContainer" style="height: 100px; width: 100%; display: block">
                    <div *ngIf="stackvelocitychartLoader" class="skeleton skeleton-health-status">
                    </div>
                    <div class="info_text">🚧Logic Under Construction 🚧</div>
                  </div>
                  <div class="heading">Asset Health Bar</div>
                </div>
                <!-- --------------------------------------ALERTS STARTS-------------------------------------- -->
                <div class="chartBoxWrap ch_box orien">
                  <div class="settingArea">
                    <div class="heading settingBtn">
                      Machine Alert Summary (24 Hours)
                    </div>
                  </div>
                  <div class="progress_data">
                    <div class="table-responsive" style="max-height: 150px">
                      <table class="table table-hover alertSummary">
                        <thead>
                          <tr>
                            <th>Alert Type</th>
                            <th>Alert Details</th>
                            <th style="text-align: right">TimeStamp</th>
                            <th style="text-align: right">Acknowledged By</th>
                            <th style="text-align: right">Acknowledged At</th>
                          </tr>
                        </thead>
                        <tbody *ngIf="noalertmessage == ''; else elseBlock">
                          <!-- <tr *ngFor="let report of errordata">
                            <td>
                              <span class="circleSpan"></span>
                            </td>
                            <td>
                              <span
                                style="cursor: pointer"
                                (click)="OnClickAlert(report)"
                                >{{ report.error | titlecase }}
                              </span>
                            </td>
                            <td class="text-right">
                              <span
                                style="cursor: pointer"
                                (click)="
                                  taketopredominantalert(
                                    $event,
                                    report.device_raw_matric_id
                                  )
                                "
                                >{{ report.time }}
                              </span>
                            </td>
                            <td>
                              <span>{{
                                report.full_name
                                  ? report.full_name
                                  : "Take Action"
                              }}</span>
                            </td>
                            <td>
                              <span *ngIf="report.ack_time; else noAckTime">
                                {{ report.ack_time }}
                              </span>
                              <ng-template #noAckTime>
                                <span>
                                  <img
                                    src="./assets/img-new/time.png"
                                    alt="time"
                                    style="width: 30px; height: 30px"
                                  />
                                </span>
                              </ng-template>
                            </td>
                          </tr> -->
                          <div class="info_loader">🚧 Logic Under Construction 🚧</div>
                        </tbody>
                        <tbody>
                          <ng-template #elseBlock>
                            <tr>
                              <td colspan="5" class="errorDisplay" style="text-align: center">
                                <!-- {{ noalertmessage }} -->
                                <div class="info_loader">🚧 Logic Under Construction 🚧</div>
                              </td>
                            </tr>
                          </ng-template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- --------------------------------------ALERTS ENDS-------------------------------------- -->
              </div>
              <!-- <div class="trends">
                <app-charts></app-charts>
              </div> -->
              <div style="display: flex; justify-content: center; margin-top: 5px">
                <button mat-raised-button color="primary" (click)="toggleTrends()">
                  {{
                  showTrendGraphs ? "Hide Trends Chart" : "Show Trends Chart"
                  }}
                </button>
              </div>
              <div class="section" *ngIf="showTrendGraphs">
                <div class="sectionHeading">Trends (Actual)</div>
                <div class="trendsFilterButtons">
                  <button (click)="handleTrendsFilter('hour')" mat-stroked-button color="primary" [ngClass]="{
                      active: trendsFilter === 'hour'
                    }">Hourly</button>
                  <button (click)="handleTrendsFilter('day')" mat-stroked-button color="primary" [ngClass]="{
                    active: trendsFilter === 'day'
                  }">Daily</button>
                  <button (click)="handleTrendsFilter('week')" mat-stroked-button color="primary" [ngClass]="{
                    active: trendsFilter === 'week'
                  }">Weekly</button>
                  <button (click)="openStackedModalModal()" mat-stroked-button color="primary">Stacked</button>
                </div>
                <div class="summary_boxes_outer">
                  <!-- <div class="summaryBox">
                    <ng-container *ngIf="accLoading; else trendscurrentid">
                      <app-spinner
                        class="spinner-container charts-loader"
                      ></app-spinner>
                    </ng-container>
                    <ng-template #trendscurrentid>
                      <app-line-chart
                        *ngIf="
                          accelerationLineData &&
                          accelerationLineData.length > 0
                        "
                        [chartContainerId]="'trends-acc'"
                        [chartData]="accelerationLineData[0]"
                        [chartOptions]="accLineChartOptions"
                        [chartSymbol]="accLineUnit"
                        [chartBgColors]="accelerationColors[0]"
                        [movingAvgData]="accLineMovingAvg"
                        [movingCount]="accMovingCount"
                        [metricIds]="'6,7,8'"
                        [asset_id]="asset_id"
                        [device_id]="device_id"
                        [subsystem_id]="subsystem_id"
                        class="windTemp"
                      ></app-line-chart>
                      @if(accelerationLineData.length == 0){
                      <div
                        class="h5 d-flex justify-content-center align-items-center"
                      >
                        ACCELERATION
                      </div>
                      <div
                        class="d-flex justify-content-center align-items-center mt-2"
                        *ngIf="velLineData.length == 0"
                      >
                        No Data Available
                      </div>
                      }
                    </ng-template>
                  </div> -->
                  <div class="summaryBox">
                    <ng-container *ngIf="tempLoading; else tempid">
                      <app-spinner class="spinner-container charts-loader"></app-spinner>
                    </ng-container>
                    <ng-template #tempid>
                      <app-line-chart *ngIf="tempLineData && tempLineData.length > 0" [chartContainerId]="'trends-temp'"
                        [chartData]="tempLineData[0]" [chartOptions]="tempLineChartOptions" [chartSymbol]="tempLineUnit"
                        [chartBgColors]="tempColors[0]" [movingAvgData]="tempLineMovingAvg"
                        [movingCount]="tempMovingCount" [metricIds]="'1,2'" [asset_id]="asset_id"
                        [device_id]="device_id" [subsystem_id]="subsystem_id" class="windTemp"></app-line-chart>
                      @if(tempLineData.length == 0){
                      <div class="h5 d-flex justify-content-center align-items-center">
                        TEMPERATURE
                      </div>
                      <div class="d-flex justify-content-center align-items-center mt-2"
                        *ngIf="velLineData.length == 0">
                        No Data Available
                      </div>
                      }
                    </ng-template>
                  </div>
                  <div class="summaryBox">
                    <ng-container *ngIf="velLoading; else velid">
                      <app-spinner class="spinner-container charts-loader"></app-spinner>
                    </ng-container>
                    <ng-template #velid>
                      <app-line-chart *ngIf="velLineData && velLineData.length > 0"
                        [chartContainerId]="'trends-velocity'" [chartData]="velLineData[0]"
                        [chartOptions]="velLineChartOptions" [chartSymbol]="velLineUnit" [chartBgColors]="velColors[0]"
                        [movingAvgData]="velLineMovingAvg" [movingCount]="velMovingCount" [metricIds]="'29,30,31'"
                        [asset_id]="asset_id" [device_id]="device_id" [subsystem_id]="subsystem_id"
                        class="windTemp"></app-line-chart>
                      @if(velLineData.length == 0){
                      <div class="h5 d-flex justify-content-center align-items-center">
                        VELOCITY
                      </div>
                      <div class="d-flex justify-content-center align-items-center mt-2"
                        *ngIf="velLineData.length == 0">
                        No Data Available
                      </div>
                      }
                    </ng-template>
                  </div>
                  <div class="summaryBox">
                    <ng-container *ngIf="audibleLoading; else audibleid">
                      <app-spinner class="spinner-container charts-loader"></app-spinner>
                    </ng-container>
                    <ng-template #audibleid>
                      <app-line-chart *ngIf="audibleLineData && audibleLineData.length > 0"
                        [chartContainerId]="'trends-audible'" [chartData]="audibleLineData[0]"
                        [chartOptions]="audibleLineChartOptions" [chartSymbol]="audibleLineUnit"
                        [chartBgColors]="audibleColors[0]" [movingAvgData]="audibleLineMovingAvg"
                        [movingCount]="audibleMovingCount" [metricIds]="'36'" [asset_id]="asset_id"
                        [device_id]="device_id" [subsystem_id]="subsystem_id" class="windTemp"></app-line-chart>
                      @if(audibleLineData.length == 0){
                      <div class="h5 d-flex justify-content-center align-items-center">
                        AUDIBLE
                      </div>
                      <div class="d-flex justify-content-center align-items-center mt-2"
                        *ngIf="velLineData.length == 0">
                        No Data Available
                      </div>
                      }
                    </ng-template>
                  </div>
                  <div class="summaryBox">
                    <ng-container *ngIf="usoundLoading; else usoundid">
                      <app-spinner class="spinner-container charts-loader"></app-spinner>
                    </ng-container>
                    <ng-template #usoundid>
                      <app-line-chart *ngIf="usoundLineData && usoundLineData.length > 0"
                        [chartContainerId]="'trends-usound'" [chartData]="usoundLineData[0]"
                        [chartOptions]="usoundLineChartOptions" [chartSymbol]="usoundLineUnit"
                        [chartBgColors]="usoundColors[0]" [movingAvgData]="usoundLineMovingAvg"
                        [movingCount]="usoundMovingCount" [metricIds]="'35'" [asset_id]="asset_id"
                        [device_id]="device_id" [subsystem_id]="subsystem_id" class="windTemp"></app-line-chart>
                      @if(usoundLineData.length == 0){
                      <div class="h5 d-flex justify-content-center align-items-center">
                        ULTRASOUND
                      </div>
                      <div class="d-flex justify-content-center align-items-center mt-2"
                        *ngIf="velLineData.length == 0">
                        No Data Available
                      </div>
                      }
                    </ng-template>
                  </div>
                  <div class="summaryBox">
                    <ng-container *ngIf="flowLoading; else flowid">
                      <app-spinner class="spinner-container charts-loader"></app-spinner>
                    </ng-container>
                    <ng-template #flowid>
                      <app-line-chart *ngIf="flowLineData && flowLineData.length > 0" [chartContainerId]="'trends-flow'"
                        [chartData]="flowLineData[0]" [chartOptions]="flowLineChartOptions" [chartSymbol]="flowLineUnit"
                        [chartBgColors]="flowColors[0]" [movingAvgData]="flowLineMovingAvg"
                        [movingCount]="flowMovingCount" [metricIds]="'36'" [asset_id]="asset_id" [device_id]="device_id"
                        [subsystem_id]="subsystem_id" class="windTemp"></app-line-chart>
                      @if(flowLineData.length == 0){
                      <div class="h5 d-flex justify-content-center align-items-center">
                        FLOW
                      </div>
                      <div class="d-flex justify-content-center align-items-center mt-2"
                        *ngIf="flowLineData.length == 0">
                        No Data Available
                      </div>
                      }
                    </ng-template>
                  </div>
                  <div class="summaryBox">
                    <ng-container *ngIf="pressureLoading; else pressureid">
                      <app-spinner class="spinner-container charts-loader"></app-spinner>
                    </ng-container>
                    <ng-template #pressureid>
                      <app-line-chart *ngIf="pressureLineData && pressureLineData.length > 0"
                        [chartContainerId]="'trends-pressure'" [chartData]="pressureLineData[0]"
                        [chartOptions]="pressureLineChartOptions" [chartSymbol]="pressureLineUnit"
                        [chartBgColors]="pressureColors[0]" [movingAvgData]="pressureLineMovingAvg"
                        [movingCount]="pressureMovingCount" [metricIds]="'36'" [asset_id]="asset_id"
                        [device_id]="device_id" [subsystem_id]="subsystem_id" class="windTemp"></app-line-chart>
                      @if(pressureLineData.length == 0){
                      <div class="h5 d-flex justify-content-center align-items-center">
                        PRESSURE
                      </div>
                      <div class="d-flex justify-content-center align-items-center mt-2"
                        *ngIf="pressureLineData.length == 0">
                        No Data Available
                      </div>
                      }
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="ctdTabset"></div>
    </div>
  </div>

  <!-- <app-cylinder-stack-chart [asset_id]="asset_id" [device_id]="device_id" [client_id]="client_id"
    [subsystem_id]="subsystem_id" /> -->
</div>

@if(showFlowPressModal){
<app-cylinder-modal (closeModal)="closeModal($event)" [data]="flowPressModalData"></app-cylinder-modal>
}

@if(showStackedModal){
<app-sync-charts-modal [asset_id]="asset_id" [device_id]="device_id" [client_id]="client_id"
  [subsystem_id]="subsystem_id" (closeStackedModal)="closeStackedModal($event)"></app-sync-charts-modal>
}